import Alpine from "alpinejs";
import persist from "@alpinejs/persist";
Alpine.plugin(persist);

import focus from "@alpinejs/focus";
Alpine.plugin(focus);

import collapse from "@alpinejs/collapse";
Alpine.plugin(collapse);

window.Alpine = Alpine;

import * as _utils from "./~utils.js";
window.getJson = _utils.getJson;
//window.formatFileSize = _utils.formatFileSize;
window.hl = _utils.hl;
window.slugify = _utils.slugify;
window._u = _utils;

function consoleUI(current_nav, prefix = "console__") {
	return {
		screen: "desktop",

		current_nav: current_nav,
		ui_topnav_title: "Untitled",

		show_sidenav: this.$persist(true).as(prefix + "show_sidenav"),

		show_sidenav_mobile: false,

		show_topfloat: false,
		name_topfloat: "",

		show_bottomfloat: false,
		name_bottomfloat: "",

		show_person: false,

		init() {
			console.debug("consoleUI: init() current_nav=" + this.current_nav);
			console.debug("sidenavOpen: ", this.sidenavOpen);

			window.addEventListener("resize", () => this.check_screen());
			window.dispatchEvent(new Event("resize"));
		},

		check_screen() {
			if (window.innerWidth < 768) this.screen = "mobile";
			else this.screen = "desktop";

			this.show_sidenav_mobile = false;

			console.debug("screen: ", this.screen);
		},

		open_sidenav() {
			// console.log("open_sidenav()" + this.screen);
			if (this.screen == "desktop") this.show_sidenav = true;
			if (this.screen == "mobile") this.show_sidenav_mobile = true;
		},
		close_sidenav() {
			// console.log("close_sidenav()" + this.screen);
			if (this.screen == "desktop") this.show_sidenav = false;
			if (this.screen == "mobile") this.show_sidenav_mobile = false;
		},

		no_float() {
			this.show_topfloat = false;
			this.name_topfloat = "";
			this.show_bottomfloat = false;
			this.name_bottomfloat = "";
		},

		modal_name: "modal1",
		modal_open: false,
		modal_position: { top: 0, left: 0 },
		modal_input: null,

		openModal(modal_name = null, modal_input = null, is_context = false, callback = null) {
			console.debug("openModal:" + modal_name);

			this.modal_input = modal_input;

			console.log("modal_input=", modal_input);

			const pr = 40; // padding right
			const pb = 40; // padding bottom

			const win_w = window.innerWidth;
			const win_h = window.innerHeight;

			if (is_context) {
				console.log("this.$event.clientX: " + this.$event.clientX);
				this.modal_position.left = this.$event.clientX - 10;
				this.modal_position.top = this.$event.clientY - 10;
			} else {
				let pos = this.$el.getBoundingClientRect();
				this.modal_position.top = pos.top + pos.height + window.scrollY;
				this.modal_position.left = pos.left;
			}

			if (modal_name) this.modal_name = modal_name;
			this.modal_open = true;

			if (typeof callback === "function") {
				callback();
			}

			this.$nextTick(() => {
				const w = document.getElementById("modal_container").getBoundingClientRect().width;
				const h = document.getElementById("modal_container").getBoundingClientRect().height;

				if (this.modal_position.left + w > win_w) {
					this.modal_position.left = win_w - w - pr;
					console.debug("new left");
				}

				if (this.modal_position.top + h > win_h) {
					this.modal_position.top = win_h - h - pb;
					console.debug("new top");
				}
			});
		},

		// dd_name: "fileoption",
		// dd_open: false,
		// dd_position: { top: 0, left: 0 },
		// dd_input: null,

		// openDropdown(dd_name = null, dd_input = null, is_context = false, callback = null) {
		// 	console.debug("openDropdown:" + dd_name);

		// 	this.dd_input = dd_input;

		// 	console.log("dd_input=", dd_input);

		// 	const pr = 40; // padding right
		// 	const pb = 40; // padding bottom

		// 	const win_w = window.innerWidth;
		// 	const win_h = window.innerHeight;

		// 	if (is_context) {
		// 		console.log("this.$event.clientX: " + this.$event.clientX);
		// 		this.dd_position.left = this.$event.clientX - 10;
		// 		this.dd_position.top = this.$event.clientY - 10;
		// 	} else {
		// 		let pos = this.$el.getBoundingClientRect();
		// 		this.dd_position.top = pos.top + pos.height + window.scrollY;
		// 		this.dd_position.left = pos.left;
		// 	}

		// 	if (dd_name) this.dd_name = dd_name;
		// 	this.dd_open = true;

		// 	if (typeof callback === "function") {
		// 		callback();
		// 	}

		// 	this.$nextTick(() => {
		// 		const w = document.getElementById("dd_container").getBoundingClientRect().width;
		// 		const h = document.getElementById("dd_container").getBoundingClientRect().height;
		// 		//console.log("win_w:"+win_w+" dd_container_width: " + w);
		// 		//console.log("left:"+pos.left + "w:"+w + "="+ ( pos.left+w));
		// 		// console.log("win_h:"+win_h+" dd_container_width: " + w);
		// 		// console.log("top:"+pos.top + "w:"+w + "="+ ( pos.left+w));

		// 		if (this.dd_position.left + w > win_w) {
		// 			this.dd_position.left = win_w - w - pr;
		// 			console.debug("new left");
		// 		}

		// 		if (this.dd_position.top + h > win_h) {
		// 			this.dd_position.top = win_h - h - pb;
		// 			console.debug("new top");
		// 		}
		// 	});
		// },
	};
}
Alpine.data("consoleUI", consoleUI);
// Alpine.store("console", consoleUI);

document.addEventListener("alpine:init", () => {
	Alpine.store("topnav", {
		title: "",
	});
});



/* 
// if ("serviceWorker" in navigator) {
// 	window.addEventListener("load", () => {
// 		navigator.serviceWorker
// 			.register("/app/service-worker.js")
// 			.then((registration) => {
// 				console.log("ServiceWorker registration successful:", registration);
// 			})
// 			.catch((error) => {
// 				console.log("ServiceWorker registration failed:", error);
// 			});
// 	});

// 	console.debug("serviceWorker : started");
// }
*/

// function _blockSelectImage(_prefix) {
// 	return {
// 		prefix: _prefix, // s3 root folder
// 		listing_files: [],

// 		current_folder: "", // no local storage because it reinit from the initial value

// 		open: false,
// 		openUp: false,
// 		placeholder: "Browse Image",
// 		initail: "",

// 		selected: "",
// 		search: "",
// 		options: [
// 			{ value: "portrait/pic-01.png", label: "pic-01.png (512x512)" },
// 			{ value: "portrait/pic-02.png", label: "pic-02.png (512x512)" },
// 			{ value: "portrait/pic-03.png", label: "pic-03.png (512x512)" },
// 			{ value: "portrait/pic-04.png", label: "pic-04.png (512x512)" },
// 			{ value: "portrait/pic-05.png", label: "pic-05.png (512x512)" },
// 			{ value: "portrait/pic-06.png", label: "pic-06.png (512x512)" },
// 			{ value: "portrait/pic-07.png", label: "pic-07.png (512x512)" },
// 			{ value: "portrait/pic-08.png", label: "pic-08.png (512x512)" },
// 			{ value: "portrait/pic-09.png", label: "pic-09.png (512x512)" },
// 			{ value: "portrait/pic-10.png", label: "pic-10.png (512x512)" },
// 			{ value: "portrait/pic-11.png", label: "pic-11.png (512x512)" },
// 			{ value: "portrait/pic-12.png", label: "pic-12.png (512x512)" },
// 			{ value: "portrait/pic-13.png", label: "pic-13.png (512x512)" },
// 			{ value: "portrait/pic-14.png", label: "pic-14.png (512x512)" },
// 			{ value: "portrait/pic-15.png", label: "pic-15.png (512x512)" },
// 			{ value: "portrait/pic-16.png", label: "pic-16.png (512x512)" },
// 		],

// 		init() {
// 			console.log("_blockSelectImage INIT prefix=" + this.prefix);

// 			this.$nextTick(() => {
// 				this.initial = this.selected;
// 				this.current_folder = this.getCurrentFolder(this.initial);

// 				console.log("_blockSelectImage initial=" + this.initial);
// 				console.log("_blockSelectImage current_folder=" + this.current_folder);

// 				this.load(this.prefix + this.current_folder);
// 			});
// 		},

// 		getCurrentFolder(path) {
// 			if (!path.endsWith("/")) {
// 				// Remove filename if present
// 				path = path.substring(0, path.lastIndexOf("/") + 1);
// 			}
// 			return path;
// 		},

// 		getParentFolder(path = this.current_folder, root = "/a/") {
// 			// Ensure root ends with /
// 			root = root.endsWith("/") ? root : root + "/";

// 			// Remove trailing slash if present
// 			path = path.endsWith("/") ? path.slice(0, -1) : path;

// 			// Prevent going higher than root
// 			if (path === root.slice(0, -1)) return root;

// 			// Find last slash position
// 			const idx = path.lastIndexOf("/");

// 			if (idx === -1) return root;

// 			const parent = path.slice(0, idx + 1);

// 			// Ensure we don't go above root
// 			return parent.length < root.length ? root : parent;
// 		},

// 		load(folder) {
// 			console.log("Loading folder:", folder);
// 			fetch("/api/s3/browse?folder=" + folder)
// 				.then((r) => r.json())
// 				.then((json) => {
// 					if (!json.success) return;
// 					console.log("_blockSelectImage():", json); // 👈 See the full JSON response here
// 					this.listing_files = json.data.files;
// 					this.current_folder = folder;

// 					this.options = this.listing_files
// 						.filter(({ kind }) => kind === "image" || kind === "folder")
// 						.map(({ s3_key, folder_path, filename, kind, format, size, width, height }) => ({
// 							value: s3_key.replace(new RegExp(`^${this.prefix}/?`), ""), // ii-thatslight/a/*** to  ***
// 							label: kind === "folder" ? `${filename}` : `${filename} (${width}x${height})`,
// 							// s3_key: s3_key,
// 							// filename: filename,
// 							kind: kind,
// 							// format: format,
// 							// size: size,
// 							// width: width,
// 							// height: height,
// 						}));
// 				});
// 		},
// 	};
// }

// Alpine.data("_blockSelectImage", _blockSelectImage);
